module.exports = __webpack_public_path__ + "static/img/success2.9f488cd8.png";